/**
 * Libellé d'un jalon, UNIQUE source pour toutes les surfaces (frise, page carte, classement,
 * tableau de bord). Un jalon n'est annoncé comme une « première fois » que lorsque c'en est
 * une : le serveur pose `season_scope` sur le jalon dès que la carrière du joueur précède
 * notre suivi (première saison connue antérieure + apparitions senior comptées), et le
 * libellé est alors borné à la saison.
 *
 * Signalé le 24/09/2026 par un scout sur Raphaël Le Guen, dont la frise datait ses
 * « premières minutes » du 20/09/2026 alors qu'il avait joué le 29/08/2025 à Lens. Mesuré
 * ensuite en production : 79 % des fiches à jalons affichaient une fausse première fois.
 */
export const seasonLabel = (s) => (Number.isInteger(s) ? `${s}-${String(s + 1).slice(2)}` : null);

export function milestoneLabel(m, t) {
  const season = seasonLabel(m?.season_scope);
  return season
    ? t(`milestone.${m.type}_season`, { season })
    : t(`milestone.${m.type}`);
}
